export default __webpack_public_path__ + "static/2-ea3668ca2553b3452b1a4e173fd45792.png";